import { LBJiraIcon } from '@linearb/buzz';

const ConnectJiraWrapper = ({ children }) => {
  return (
    <div className='mt-6 flex flex-col'>
      <div className='flex items-center pb-3'>
        <div className='flex items-center pb-3'></div>
        <LBJiraIcon className='size-5' />
        <div className='ml-3 text-lg font-medium'>Connect Jira</div>
      </div>
      {children}
    </div>
  );
};

export default ConnectJiraWrapper;
